import tourStep from "tourStep";
import { TourProvider } from "@reactour/tour";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";
import EndPointServices from "@services/ApiServices";

export default function TourRoute(props) {
  const [step, setStep] = useState([]);
  const location = useLocation();
  const [state, dispatch] = useContext(GlobalContext);

  useEffect(() => {
    if (props.tpStep === 1) {
      setStep(tourStep.tourRPA);
    } else if (props.tpStep === 2) {
      setStep(tourStep.tourRPACadastro);
    } else if (props.tpStep === 3) {
      setStep(tourStep.tourGerenciar);
    } else if (props.tpStep === 4) {
      setStep(tourStep.tourRegra);
    }
  }, [location.pathname]);

  async function handleTourClose() {
    let data = {
      id_usuario_guid: state.dadosusuario?.id_usuario_guid,
      id_usuario: state.dadosusuario?.id_usuario,
      tourclose: `tour_${props.tpStep}`,
    };

    await EndPointServices.Partilha_TourClose(data);
  }

  return (
    <TourProvider
      key={step.length} // força remount quando o step muda
      onClose={() => {
        localStorage.setItem(`tour_${props.tpStep}`, "true");
      }}
      steps={step}
      styles={{
        dot: (base, state) => ({
          ...base,
          border: state.current ? "none" : "2px solid rgb(202 202 202)",
          backgroundColor: state.current ? "#b3b3b3" : "#fff",
        }),
        // caixa de conteúdo
        popover: (base) => ({
          ...base,
          background: "#fff",
          color: "#333",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          fontSize: "16px",
        }),
        // botões
        close: (base) => ({
          ...base,
          color: "#FF5733",
          fontSize: "18px",
        }),
      }}
      onClickClose={() => {
        let tour = {
          ...state.tourclose,
          [`tour_${props.tpStep}`]: true,
        };

        dispatch({
          type: "SET_TOURCLOSE",
          payload: tour,
        });

        UtilServices.setStorage("tourclose", tour);
        handleTourClose();
      }}
    >
      {props.children}
    </TourProvider>
  );
}
